import React from 'react'
import ProjectCard from '../components/ProjectCard'
import '../style/style.css'
import {motion} from 'framer-motion'

export default function Project() {
    return (
        <motion.div 
            initial={{opacity:0,y:"-100%"}} 
            animate={{opacity:1,y:0}} 
            exit={{opacity:0,y:"-100%"}} 
            transition={{type:"spring"}}
            className="col-lg-9 col-md-9 col-sm-9 col-xs-12">
            <div className="container"  style={{overflowX:"hidden" , overflowY:"auto"}}>
             <h1 id="project">Project</h1>
             <ProjectCard /> 
            </div>
        </motion.div>
    )
}
